<div
  class="cpt-modal app-confirmation-question-popup ConfirmationQuestionPopupComponent-revolution-dialog relative dialog-content-p-0 mat-dialog-actions-pb-20"
  >
  <h2 class="font-canelablack-primary text-4xl" mat-dialog-title>
    {{ translatedTitle }}
  </h2>

  @if (!data?.useInnerHtml) {
    <mat-dialog-content class="mat-typography">
      <div class="flex gap-2 items-center">
        @if (showTextSpinner) {
          <mat-spinner [diameter]="50"></mat-spinner>
        }
        <div class="flex-1">
          {{ translatedText }}
        </div>
      </div>
    </mat-dialog-content>
  }
  @if (data?.useInnerHtml) {
    <mat-dialog-content
      class="mat-typography"
      [innerHTML]="translatedText"
      >
    </mat-dialog-content>
  }

  <mat-divider></mat-divider>
  <mat-dialog-actions>
    <button class="dialog-close-button" (click)="onButtonClicked(false)">
      <mat-icon svgIcon="close"></mat-icon>
    </button>

    @if (data.cancel) {
      <button
        class="back revolution btn-dialog"
        mat-button
        mat-stroked-button
        color="secondary"
        mat-dialog-close
        (click)="onButtonClicked(false)"
        >
        {{ translatedCancel }}
      </button>
    }

    @if (data.save) {
      <button
        data-cy="confirmation-question-submit"
        ef-feature-id="customerPortal.customer-portal.confirmation-question-popup.submit.button"
        mat-button
        mat-flat-button
        [color]="saveButtonColor"
        class="revolution btn-dialog"
        cdkFocusInitial
        (click)="onButtonClicked(true)"
        [disabled]="saving"
        >
        @if (saving) {
          <mat-spinner [diameter]="16"></mat-spinner>
        }
        {{ translatedSave }}
      </button>
    }
  </mat-dialog-actions>
</div>
